import { createRoute } from '@tanstack/react-router'
import { Route as cmsLayoutRoute } from './layout'

export const Route = createRoute({
  getParentRoute: () => cmsLayoutRoute,
  path: '/cms/articles/$articleId',
}).lazy(() => import('./articles.$articleId.lazy').then((d) => d.Route))
